import LeaveAllocationSummary, { LEAVE_LABELS } from "components/LeaveAllocations/LeaveAllocationSummary";
import React, { Component } from "react";
import { Modal, Alert } from "react-bootstrap";
import moment from "moment";
import Button from "components/CustomButton/CustomButton.jsx";
import { fetchFormRequest } from "../../api/form";
import { getFullName } from "helpers/functions/employee";
import { getFormattedFormType } from 'helpers/functions/form';

class EmployeeDetailsModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            resource: {
                _id: null
            }
        }
    }

    componentDidUpdate(prevProps) {
        const { id } = this.props;

        if (id && id !== prevProps.id) {
            this.fetchForm(id)
        }
    }

    fetchForm = (id) => {
        fetchFormRequest(id, result => this.setState({resource: result}), error => console.log(error))
    }

    render() {
        const { 
            _id,
            formType,
            employee,
            date,
            timeIn,
            lunchStart,
            lunchEnd,
            timeOut,
            reason,
            approvedBy,
            applicationType,
            paymentType,
            leaveType,
            leaveTypeDetail,
            startDate,
            endDate,
            leaveDays,
            leavePaidDays,
            leaveWithoutPayDays,
            timeFrom,
            timeTo,
            department,
            hoursRequested,
            travelArea
        } = this.state.resource;

        const {
            showModal
        } = this.props;

        return (
            <Modal show={showModal} onHide={this.props.closeModal}>
                <Modal.Header closeButton>
                <Modal.Title>Form to Approve</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.props.error && <Alert bsStyle="danger" role="alert">{this.props.error}</Alert>}
                    <div className="typo-line">
                        <div>
                        <p className="category">Form ID</p>
                        {_id || 'N/A'}
                        </div>
                    </div>
                    <div className="typo-line">
                        <div>
                        <p className="category">Employee</p>
                        {employee ? getFullName(employee) : 'N/A'}
                        </div>
                    </div>
                    <div className="typo-line">
                        <div>
                        <p className="category">Form Type</p>
                        {getFormattedFormType(formType, applicationType) || 'N/A'}
                        </div>
                    </div>
                    {formType === "attendance" &&
                        <div>
                            <div className="typo-line">
                                <div>
                                <p className="category">Date</p>
                                {date ? moment(date).format('MMMM Do YYYY') : 'N/A'}
                                </div>
                            </div>
                            <div className="typo-line">
                                <div>
                                <p className="category">No Time In</p>
                                {timeIn || 'N/A'}
                                </div>
                            </div>
                            <div className="typo-line">
                                <div>
                                <p className="category">No Lunch Start</p>
                                {lunchStart || 'N/A'}
                                </div>
                            </div>
                            <div className="typo-line">
                                <div>
                                <p className="category">No Lunch End</p>
                                {lunchEnd || 'N/A'}
                                </div>
                            </div>
                            <div className="typo-line">
                                <div>
                                <p className="category">No Time Out</p>
                                {timeOut || 'N/A'}
                                </div>
                            </div>
                        </div>
                    }
                    {formType === "leave-undertime" &&
                        <div>
                            <div className="typo-line">
                                <div>
                                <p className="category">Application Type</p>
                                {applicationType || 'N/A'}
                                </div>
                            </div>
                            {applicationType === "leave" &&
                                <div>
                                    <div className="typo-line">
                                        <div>
                                        <p className="category">Payment Type</p>
                                        {paymentType || 'N/A'}
                                        </div>
                                    </div>
                                    <div className="typo-line">
                                        <div>
                                        <p className="category">Leave Type</p>
                                        {LEAVE_LABELS[leaveType] || leaveType || 'N/A'}
                                        </div>
                                    </div>
                                    <LeaveAllocationSummary allocations={this.state.resource.leaveAllocations || []} days={this.state.resource.leaveDayAllocations || []} />
                                    {leaveType === 'other' && (
                                        <div className="typo-line">
                                            <div>
                                            <p className="category">Details</p>
                                            {leaveTypeDetail || 'N/A'}
                                            </div>
                                        </div>
                                    )}
                                    <div className="typo-line">
                                        <div>
                                        <p className="category">Start Date</p>
                                        {startDate ? moment(startDate).format('MMMM Do YYYY') : 'N/A'}
                                        </div>
                                    </div>
                                    <div className="typo-line">
                                        <div>
                                        <p className="category">End Date</p>
                                        {endDate ? moment(endDate).format('MMMM Do YYYY') : 'N/A'}
                                        </div>
                                    </div>
                                    {paymentType === "withPay" && (
                                        <div>
                                            <div className="typo-line">
                                                <div>
                                                <p className="category">Requested / Paid / Without Pay</p>
                                                {leaveDays !== null && leaveDays !== undefined ? leaveDays : 'N/A'} / {leavePaidDays !== null && leavePaidDays !== undefined ? leavePaidDays : leaveDays} / {leaveWithoutPayDays || 0} days
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            }
                            {applicationType === "undertime" &&
                                <div>
                                    <div className="typo-line">
                                        <div>
                                        <p className="category">Date</p>
                                        {date ? moment(date).format('MMMM Do YYYY') : 'N/A'}
                                        </div>
                                    </div>
                                    <div className="typo-line">
                                        <div>
                                        <p className="category">Time From</p>
                                        {timeFrom || 'N/A'}
                                        </div>
                                    </div>
                                    <div className="typo-line">
                                        <div>
                                        <p className="category">Time To</p>
                                        {timeTo || 'N/A'}
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                    {formType === "travel-order" &&
                        <div>
                            <div className="typo-line">
                                <div>
                                <p className="category">Department</p>
                                {department ? department.departmentName : 'N/A'}
                                </div>
                            </div>
                            <div className="typo-line">
                                <div>
                                <p className="category">Travel Area</p>
                                {travelArea || 'N/A'}
                                </div>
                            </div>
                        </div>
                    }
                    {formType === "ot-request" &&
                        <div>
                            <div className="typo-line">
                                <div>
                                <p className="category">Department</p>
                                {department ? department.departmentName : 'N/A'}
                                </div>
                            </div>
                            <div className="typo-line">
                                <div>
                                <p className="category">Hours Requested</p>
                                {hoursRequested || 'N/A'}
                                </div>
                            </div>
                        </div>
                    }
                    <div className="typo-line">
                        <div>
                        <p className="category">Reason</p>
                        {reason || 'N/A'}
                        </div>
                    </div>
                    <div className="typo-line">
                        <div>
                        <p className="category">Approved By</p>
                        {approvedBy ? getFullName(approvedBy) : 'N/A'}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button 
                      bsStyle="primary" 
                      pullRight 
                      fill 
                      onClick={() => this.props.approveForm(_id)}
                    >
                        Approve
                    </Button>
                    <Button 
                      bsStyle="danger" 
                      pullRight 
                      fill
                      style={{
                        marginRight: "10px"
                      }}
                      onClick={() => this.props.rejectForm(_id)}
                    >
                        Reject
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default EmployeeDetailsModal;
